import { Vector2 } from "./Utils";
export class Input {
    constructor(listenable) {
        this.keys = new Set();
        this.aliases = new Map();
        this.mouse = {
            left: false,
            middle: false,
            right: false,
            location: new Vector2(0, 0)
        };
        listenable.addEventListener('keydown', ev => this.keyDown(ev));
        listenable.addEventListener('keyup', ev => this.keyUp(ev));
        listenable.addEventListener('pointerdown', ev => this.mouse.left = true);
        listenable.addEventListener('pointerup', ev => this.mouse.left = false);
        listenable.addEventListener('pointermove', (ev) => this.mouseMove(ev));
    }
    keyDown(ev) {
        this.keys.add(ev.code);
    }
    keyUp(ev) {
        this.keys.delete(ev.code);
    }
    setAlias(alias, code) {
        this.aliases.set(alias, code);
    }
    isPressed(code) {
        if (this.aliases.has(code)) {
            code = this.aliases.get(code);
        }
        return this.keys.has(code);
    }
    mouseMove(ev) {
        this.mouse.location = new Vector2(ev.x, ev.y);
    }
    mouseIsDown() {
        return this.mouse.left;
    }
    getMouseLocation() {
        return this.mouse.location;
    }
}
//# sourceMappingURL=Input.js.map